<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title>
                        <v-icon>mdi-account</v-icon>
                        {{ user.username }}
                    </v-card-title>
                    <v-divider/>
                    <v-card-text>
                        <div v-if="sistemaLoading">
                            Cargando...
                        </div>
                        <v-card v-else outlined small>
                            <v-card-title>
                                {{ sistema.name }}
                            </v-card-title>
                            <v-card-subtitle>
                                {{ sistema.tipo_sistema.name }}
                            </v-card-subtitle>
                            <v-card-text>
                                <v-card outlined class="d-flex align-center flex-wrap pa-1">
                                    <small class="caption mr-2">TOKEN</small>
                                    <v-divider vertical class="mr-2"/>
                                    <code style="overflow-wrap: anywhere; cursor: pointer;" @click="copy(sistema.token)">
                                        <template v-if="sistema.token">
                                            {{ sistema.token }}
                                            <v-icon size="x-small" class="ml-2">mdi-content-copy</v-icon>
                                        </template>
                                        <template v-else>SIN TOKEN</template>
                                    </code>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title>
                        {{ user.owner.name }}
                    </v-card-title>
                    <v-card-text>
                        <div>
                            <div v-if="sistemaLoading">
                                Cargando...
                            </div>
                            <div v-else>
                                <div class="d-flex flex-wrap">
                                    <JuegoCardLimited 
                                        v-for="(juego, index) of juegoList" 
                                        :key="`operadora-loteria-juego-item-${index}-${juego.id}`" 
                                        :juego="juego"
                                        class="mr-2 mb-2 flex-grow-1"
                                        />
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import SistemaService from '@/services/sistema/SistemaService';

import JuegoCardLimited from '@/components/entities/loteria/juego/card-limited';

export default {
    components: {
        JuegoCardLimited
    },
    props: {
        user: {},
    },
    data: function () {
        return {
            sistema: null,
            sistemaLoading: false,
            juegoList: [],
            juegoListLoading: false,
        }
    },
    methods: {
        get: function () {
            this.sistemaLoading = true;
            SistemaService.get()
                .then(({ sistema, juegoList }) => {
                    this.sistema = sistema;
                    this.juegoList = juegoList;
                })
                .catch((error) => {
                    console.error('Error al obtener sistema:', error);
                })
                .finally(() => {
                    this.sistemaLoading = false;
                });
        },
        async copy(text) {
            try {
                await navigator.clipboard.writeText(text);
            } catch (e) {
                console.error(e);
            }
        }
    },
    created: function () {
        this.get();
    }
}
</script>